/**
 * 箭头大小配置
 */

export type ArrowSizeType = 'none' | 'small' | 'medium' | 'large';

export interface ArrowSizeConfig {
  length: number;
  headLength: number;
  headWidth: number;
  dashSize: number;
  gapSize: number;
}

export const ARROW_SIZE_PRESETS: Record<ArrowSizeType, ArrowSizeConfig | null> = {
  none: null, // 不显示箭头
  small: {
    length: 0.8,
    headLength: 0.15,
    headWidth: 0.2,
    dashSize: 0.08,
    gapSize: 0.05,
  },
  medium: {
    length: 1.5,
    headLength: 0.25,
    headWidth: 0.3,
    dashSize: 0.1,
    gapSize: 0.06,
  },
  large: {
    length: 2.5,
    headLength: 0.4,
    headWidth: 0.5,
    dashSize: 0.15,
    gapSize: 0.08,
  },
};

export const ARROW_SIZE_LABELS: Record<ArrowSizeType, string> = {
  none: '不显示',
  small: '默认',
  medium: '中',
  large: '大',
};
